import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import CustomPagination from "../../../../component/common/CustomPagination";
import { koKRGrid } from "../../../../component/common/TableKRText";
import WngdDetailDialog from "./WngdDetailDialog"
import api from "../../../../../API";
import { useSelector } from "react-redux";
import { SearchBackDrop } from "../../../../component/common/SearchBackDrop";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function CustomToolbar(props: any) {

  // console.log('CustomToolbar props :::: ' , props)

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      />
      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>

        <Box>
          <Box sx={{fontWeight:700, marginLeft:"8px", color:"#2f9c34"}}>총 건수 :{props.totalCount ? props.totalCount : "0"} 건</Box>
          <Box sx={{fontWeight:700, marginLeft:"8px", color:"#000"}}>선택 :{props.selectCheckCnt ? props.selectCheckCnt : "0"} 개</Box>
        </Box>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>정렬</Box>
        <Select id="order" value={props.order} onChange={(e)=>props.setOrder(e.target.value)} sx={{width:"100px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"asc"}>처음</MenuItem>
          <MenuItem dense value={"desc"}>최신</MenuItem>
        </Select>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>체크결과</Box>
        <Select id="use_check" value={props.use_check} onChange={(e)=>props.setUse_check(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"T"}>사용가능</MenuItem>
          <MenuItem dense value={"C"}>내용수정</MenuItem>
          <MenuItem dense value={"F"}>사용불가</MenuItem>
          <MenuItem dense value={"None"}>미분류</MenuItem>
        </Select>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>가공결과</Box>
        <Select id="prc_yn" value={props.prc_yn} onChange={(e)=>props.setPrc_yn(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"Y"}>적합</MenuItem>
          <MenuItem dense value={"N"}>부적합</MenuItem>
          <MenuItem dense value={"None"}>미분류</MenuItem>
        </Select>

        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>소음파일</Box>
        <Select id="vn_yn" value={props.vn_yn} onChange={(e)=>props.setVn_yn(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"Y"}>있음</MenuItem>
          <MenuItem dense value={"N"}>없음</MenuItem>
        </Select> */}

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>IDX</Box>
        <TextField size="small" id="col_pk" value={props.col_pk} onChange={(e)=>props.setCol_pk(e.target.value)} sx={{width:"195px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} />
        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>이름</Box>
        <TextField size="small" id="worker" value={props.worker} onChange={(e)=>props.setWorker(e.target.value)} sx={{width:"90px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} />
        <Button variant="contained" sx={{marginLeft:"8px"}} onClick={()=>{props.setWorkerParam(); props.setColPkParam();}}>검색</Button>
        {props.adminRole && <Button variant="contained" sx={{marginLeft:"4px",backgroundColor:"#2f9c34"}} onClick={()=>{props.csqaListDown(); }}>엑셀</Button>}
      </Box>
      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>
        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>시작일(가공)</Box>
          <TextField sx={{marginLeft: "8px",fontSize:"8px"}} id="job_start_date" name="job_start_date" size="small" type="date"
                    value={props.prc_s_date} onChange={(e)=>props.setPrc_s_date(e.target.value)}
          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
            InputProps={{
              style: {width: "150px", height:"30px", fontSize:"14px"},
              inputProps: { 
                spellCheck: "false" // spellcheck를 false로 설정
              },
            }}
          />

          <Box sx={{marginLeft:"8px", color:"#1976d2"}}>종료일(가공)</Box>
          <TextField sx={{marginLeft: "8px",fontSize:"8px"}} id="job_end_date" name="job_end_date" size="small" type="date"
                    value={props.prc_e_date} onChange={(e)=>props.setPrc_e_date(e.target.value)}
          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
            InputProps={{
              style: {width: "150px", height:"30px", fontSize:"14px"},
              inputProps: { 
                spellCheck: "false" // spellcheck를 false로 설정
              },
            }}
          />
      </Box>
      <GridToolbarQuickFilter sx={{ marginLeft: "16px" }} />
      {/* <GridToolbarQuickFilter /> */}
    </GridToolbarContainer>
  );
}

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface WngdType {
  idx: number;
  id: string;
  worker: string;
  work_date: string;
  work_yn: string;
  use_check: string;

  prc_worker: string;
  prc_date: string;
  prc_yn: string;

  isp_worker: string;
  isp_date: string;
  isp_yn: string;

  category: string;
  answer: string;

  translate_need: string;

  question_en: string;
  choice_en_1: string;
  choice_en_2: string;

  question_vi: string;
  choice_vi_1: string;
  choice_vi_2: string;

  question_ko: string;
  choice_ko_1: string;
  choice_ko_2: string;

}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const WngdTableList = () => {

  const [page, setPage] = useState(1);

  const [totalCount, setTotalCount] = useState(0);
  const [selectCheckCnt , setSelectCheckCnt] = useState(0)

  const handleSelectionModelChange = (ids:any) => {
    setSelectCheckCnt(ids.length)
  };

  const [prc_yn, setPrc_yn] = useState('모두');
  const [use_check, setUse_check] = useState('모두');
  const [worker, setWorker] = useState('');
  const [col_pk, setCol_pk] = useState('');
  const [order, setOrder] = useState('desc');

  const [p_worker, setP_worker] = useState('');
  const [p_col_pk, setP_col_pk] = useState('');

  const [prc_s_date, setPrc_s_date] = useState('');
  const [prc_e_date, setPrc_e_date] = useState('');

  const [p_prc_s_date, setP_prc_s_date] = useState('');
  const [p_prc_e_date, setP_prc_e_date] = useState('');

  const setWorkerParam = () => {
    setP_worker(worker);
    setP_prc_s_date(prc_s_date);
    setP_prc_e_date(prc_e_date);
  }

  const setColPkParam = () => {
    setP_col_pk(col_pk);
  }

  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<WngdType>({
    idx: 0,
    id: "",
    worker: "",
    work_date: "",
    work_yn: "",
    use_check: "",

    prc_worker:"",
    prc_date: "",
    prc_yn:"",

    isp_worker:"",
    isp_date: "",
    isp_yn:"",

    category: "",
    answer: "",

    translate_need:"",

    question_vi: "",
    choice_vi_1: "",
    choice_vi_2: "",

    question_en: "",
    choice_en_1: "",
    choice_en_2: "",

    question_ko: "",
    choice_ko_1: "",
    choice_ko_2: "",
  });

  // api 사용자 정보에서 페이지 정보를 담을 state
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let adminRole = auth.user.roles.some((obj:any) => ['ADMIN'].includes(obj.role));
  
  const getWngdList = async (order:string,prc_yn:string,use_check:string,worker:string) => {
    setBackdrop(true)
    var result = await api.get("/wngdList", {
      // params: {email:email,page:page,use_check:use_check}
      params: {email:email,order:order,page:page,prc_yn:(prc_yn ? prc_yn: "모두"),use_check:(use_check ? use_check: "모두"),worker:(worker ? worker: ""),col_pk:(p_col_pk ? p_col_pk: ""),p_prc_s_date:p_prc_s_date,p_prc_e_date:p_prc_e_date}
    });
    // console.log("result.data", result.data);
    setBackdrop(false)
    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        idx: data.idx ,
        id: data.id,
        worker: data.worker,
        work_date: data.work_date,
        use_check: data.use_check,

        prc_worker: data.prc_worker,
        prc_date: data.prc_date,
        prc_yn: data.prc_yn,

        isp_worker: data.isp_worker,
        isp_date: data.isp_date,
        isp_yn: data.isp_yn,

        category: data.category,
        answer: data.answer,

        question_vi: data.question_vi,
        choice_vi_1: data.choice_vi_1,
        choice_vi_2: data.choice_vi_2,

        question_en: data.question_en,
        choice_en_1: data.choice_en_1,
        choice_en_2: data.choice_en_2,

        question_ko: data.question_ko,
        choice_ko_1: data.choice_ko_1,
        choice_ko_2: data.choice_ko_2,
      };
    });

    // console.log('sample list')

    // table에 넣을 rows 데이터 state에 저장
    setRows(datas);
    // pagination에 넣을 api data 페이지 정보를 state에 저장
    setPagination(result.data.pagination);
    // console.log('result.data.pagination.total_count',result.data.pagination)
    setTotalCount(result.data.pagination.total_count);
  };

  const wngdListDown = async () =>{
    var response = await api.get("/wngdListDown", {
      params: {email:email,order:order,use_check:(use_check ? use_check: "모두"),worker:(p_worker ? p_worker: ""),col_pk:(p_col_pk ? p_col_pk: "")},
      responseType: 'arraybuffer'
    });

    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);

    // 다운로드 링크 생성
    const link = document.createElement('a');
    link.href = url;
    link.download = 'HHH리스트_다운로드.xlsx';  // 다운로드 파일 이름 설정
    document.body.appendChild(link);

    // 다운로드 링크를 클릭하여 파일 다운로드
    link.click();

    // 다운로드 후에는 생성한 링크와 Blob 객체를 해제
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  };

  useEffect(() => {
    getWngdList(order,prc_yn,use_check,p_worker);
  }, [use_check,prc_yn,page,order,p_worker,p_col_pk,p_prc_s_date,p_prc_e_date]);

  // 팝업 관리 state
  const [dialogOpen, setDialogOpen] = useState(false);

  const goDetail = (data: any) => {
    // console.log("goDetail", data);
    setRowDetail(data);
    setDialogOpen(true);
  };

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  const columns: GridColDef[] = [
    { field: "idx", headerName: "idx", headerAlign: "center", width: 84,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>idx</Box>
      )
    },
    { field: "use_check", headerName: "체크결과", headerAlign: "center", width: 120,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>검사결과</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{color:"#fff"}}>
          <Button size="small" sx={{height:"25px", color:"#fff", backgroundColor: (params.value === "F" ? "red" : (params.value === "T" ? "#498ad5" : (params.value === "T" ? "#27cc2f" : "#bbb")))}}>
            {(params.value === "F" ? "사용불가" : (params.value === "T" ? "사용가능" :(params.value === "C" ? "내용수정":"미분류")))}
          </Button>  
        </Box>
      ),
    },
    {
      field: "prc_date", headerName: "가공일자", headerAlign: "center", headerClassName: "header-style", width: 150, type: "date",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>가공일자</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    {
      field: "question_vi", headerName: "질문 내용(vi)", headerAlign: "center", headerClassName: "header-style", width: 320,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>질문 내용(vi)</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },

    {
      field: "question_ko", headerName: "질문 내용(ko)", headerAlign: "center", headerClassName: "header-style", width: 320,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>질문 내용(ko)</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },

    {
      field: "question_en", headerName: "질문 내용(en)", headerAlign: "center", headerClassName: "header-style", width: 320,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>질문 내용(en)</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },

    // { field: "use_check", headerName: "검사결과", headerAlign: "center", width: 120,
    //   renderHeader: (params: any) => (
    //     <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>검사결과</Box>
    //   ),
    //   renderCell: (params:any) => (
    //     <Box sx={{color:"#fff"}}>
    //       <Button size="small" sx={{height:"25px", color:"#fff", backgroundColor: (params.value === "N" ? "red" : (params.value === "0" ? "#99ca27" : (params.value === "D" ? "#c09c24" : (params.value === "Y" ? "#1152a7":"#000"))))}}>
    //         {(params.value === "N" ? "부적합" : (params.value === "0" ? "제출" : (params.value === "D" ? "보류" : (params.value === "Y" ? "적합":"상태이상"))))}
    //       </Button>  
    //     </Box>
    //   ),
    // },
    // { field: "reject_rsn", headerName: "부적합사유", headerAlign: "center", width: 200,
    //   renderHeader: (params: any) => (
    //     <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>부적합사유</Box>
    //   ),
    //   renderCell: (params:any) => (
    //     <Box sx={{fontWeight:700, fontSize:"12px"}}>{params.value == "None"?  "" : params.value}</Box>
    //   ),
    // },
  ];

  const [backdrop, setBackdrop] = useState<boolean>(false)

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
        
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-cell--textLeft": {justifyContent : "center"},
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {padding : "16px"},
        ".MuiDataGrid-cellContent": {fontSize : "12px", cursor:"pointer"},
      }}
    >
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", marginLeft:"8px" }}><h3>07. Winogrande (WNGD)</h3></Box>
        <Box sx={{ height: "600px", width: "100%",position:"relative" }}>
          {backdrop && ( <SearchBackDrop/> )}
          <DataGrid
            editMode="row"
            rows={rows}
            columns={columns}
            onRowDoubleClick={(e) => goDetail(e.row)}
            checkboxSelection
            onSelectionModelChange={handleSelectionModelChange}
            pageSize={100}
            rowHeight={38}
            components={{ Toolbar: CustomToolbar, Footer: CustomFooter}}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },

                totalCount:totalCount,
                selectCheckCnt: selectCheckCnt,

                prc_yn: prc_yn,
                setPrc_yn: setPrc_yn,

                prc_s_date: prc_s_date,
                setPrc_s_date: setPrc_s_date,
                prc_e_date: prc_e_date,
                setPrc_e_date: setPrc_e_date,

                use_check: use_check,
                setUse_check: setUse_check,

                order: order,
                setOrder: setOrder,

                worker: worker,
                setWorker: setWorker,
                setWorkerParam: setWorkerParam,

                col_pk: col_pk,
                setCol_pk: setCol_pk,
                setColPkParam: setColPkParam,

                wngdListDown: wngdListDown,

                adminRole: adminRole,

              },
            }}
            getRowId={(row) => row.idx}
            localeText={koKRGrid}
            experimentalFeatures={{ newEditingApi: true }}
            onFilterModelChange={(e) => console.log('이벤트!!!',e)}
            // sx={{cursor:"pointer"}}
          />
        </Box>
      </ThemeProvider>
      {dialogOpen == true ? (
        <WngdDetailDialog
          // dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          rowDetail={rowDetail}
          setRowDetail={setRowDetail}
          getWngdList={getWngdList}
          p_order={order}
          p_prc_yn={prc_yn}
          p_use_check={use_check}
          p_worker={p_worker}
          p_prc_s_date={p_prc_s_date}
          p_prc_e_date={p_prc_e_date}
        />
      ) : ""}
    </Box>
  );
};
export default WngdTableList;
